import React, { memo, useEffect, useState } from 'react';

import { classNameBind } from '@wconcept/wconcept-ui/styles/common';

import * as S from './style';

interface IProps {
  mode?: string;
  className?: string;
  level?: number;
  children?: React.ReactNode;
  suffix?: React.ReactNode;
}

const Title = ({ className = '', level = 1, children, suffix }: IProps) => {
  const [h, setH] = useState<string>('h1');

  useEffect(() => {
    setH(`h${level}`);
  }, [level]);

  const param = {
    className: classNameBind(['title', className]),
  };

  return (
    <S.Title as={h} {...param}>
      {children}
      {suffix && <S.Suffix>{suffix}</S.Suffix>}
    </S.Title>
  );
};

export default memo(Title);
